import React from 'react';
import useFacetFiltering from '~/contexts/facetFiltering/useFacetFiltering';

interface Props {}

const HiddenFilteringList: React.FC<Props> = () => {
  const { facets } = useFacetFiltering();

  return (
    <div className="hidden">
      {facets
        ?.filter(f => f.slug !== 'category' && f.children)
        .map(facetGroup => (
          <section key={facetGroup.slug} aria-label={facetGroup.name}>
            <span>{facetGroup.name}</span>

            <ul>
              {facetGroup.children?.map(facet => (
                <li key={facet.slug}>
                  {facet.url ? (
                    <a href={facet.url}>{facet.name}</a>
                  ) : (
                    <span>{facet.name}</span>
                  )}
                </li>
              ))}
            </ul>
          </section>
        ))}
    </div>
  );
};

export default HiddenFilteringList;
